import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const house: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M18.5,9.4997 L18.5,19.4997 L14.49,19.4997
      L14.49,14.4997 L9.49,14.4997 L9.49,19.4997 L5.5,19.4997 L5.5,9.4997
      M4,10.9997 L12,2.9997 L20,10.9997"
      />
    </svg>
  );
};
